import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { useIntl } from "react-intl";
import { useCompetitionAdminRoutes } from "hooks/useCompetitionAdminRoutes";
import { GESTION_ROUTES } from "constants/gestion-routes";

const GestionCompetitionNav = ({ competitionId }) => {
  const intl = useIntl();
  const location = useLocation();
  const routes = useCompetitionAdminRoutes(competitionId);
  const { customerId } = routes;

  if (!routes.isGestionScope || !customerId) {
    return null;
  }

  const navItems = [
    { label: intl.formatMessage({ id: "Vista general" }), path: routes.overview },
    { label: intl.formatMessage({ id: "Torneos" }), path: routes.tournaments },
    { label: intl.formatMessage({ id: "Calendario de partidos" }), path: routes.schedule },
    { label: intl.formatMessage({ id: "Locales" }), path: routes.clubs },
    { label: intl.formatMessage({ id: "Administradores" }), path: routes.managers },
    { label: intl.formatMessage({ id: "Editar detalles" }), path: routes.edit },
    { label: intl.formatMessage({ id: "Calendarización" }), path: routes.scheduling },
    { label: intl.formatMessage({ id: "Campos personalizados" }), path: routes.customFields },
  ];

  const activePath =
    navItems
      .filter((item) => location.pathname === item.path || location.pathname.startsWith(`${item.path}/`))
      .sort((a, b) => b.path.length - a.path.length)[0]?.path || routes.overview;

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 1 }}>
      <Tabs
        value={activePath}
        variant="scrollable"
        scrollButtons="auto"
        aria-label={intl.formatMessage({ id: "gestion.nav.competitions" })}
      >
        <Tab
          component={Link}
          to={GESTION_ROUTES.competitions(customerId)}
          value={GESTION_ROUTES.competitions(customerId)}
          label={intl.formatMessage({ id: "gestion.competitionNav.backToList" })}
          sx={{ minHeight: 48 }}
        />
        {navItems.map((item) => (
          <Tab
            key={item.path}
            component={Link}
            to={item.path}
            value={item.path}
            label={item.label}
            sx={{ minHeight: 48 }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default GestionCompetitionNav;
